export const XL = 'xl';
export const LG = 'lg';
export const MD = 'md';
export const SM = 'sm';
export const XS = 'xs';
export const XXS = 'xxs';
export const NUMBER_XL = 'number_xl';
export const NUMBER_LG = 'number_lg';
export const NUMBER_MD = 'number_md';
//# sourceMappingURL=sizes.js.map